var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-auth text-large"},[_c('div',{staticClass:"error-auth__message"},[_vm._v("システム連携に失敗しました。システム管理者に問い合わせをお願いします。")]),_c('a',{attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }